import { render, staticRenderFns } from "./AddressPhoneNumber.vue?vue&type=template&id=4ae15c0c&"
import script from "./AddressPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./AddressPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports